export default "/images/7c7a21ac4e895ab014015dcb9bed7845.avif";